import { createSlice } from '@reduxjs/toolkit';
import api from '../../../api';
import formErrorsHandle from '../../../utils/formErrorsHandle';

const initialState = {
  loading: false,
  companyId: '',
  side: '',
  totalTrips: [],
  tripStatus: [],
  tripFinancial: [],
  collaboration: []
};

const dashboardFiltersReducer = createSlice({
  name: 'dashboardFilters',
  initialState,
  reducers: {
    setCompanyId(state, action) {
      return {
        ...state,
        companyId: action.payload
      };
    },
    setSide(state, action) {
      return {
        ...state,
        side: action.payload
      };
    },
    getTotalTrips(state, action) {
      return {
        ...state,
        totalTrips: action.payload
      };
    },
    getTripStatus(state, action) {
      return {
        ...state,
        tripStatus: action.payload
      };
    },
    getTripFinancial(state, action) {
      return {
        ...state,
        tripFinancial: action.payload
      };
    },
    getCollaboration(state, action) {
      return {
        ...state,
        collaboration: action.payload
      };
    }
  }
});

export const DashboardActions = dashboardFiltersReducer.actions;

export const getTotalTripsAction = (data) => async (dispatch) => {
  try {
    const res = await api.post(`api/Dashboard/total-trips`, data);
    if (res.status === 200 && res?.data) {
      dispatch(DashboardActions.getTotalTrips(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getTripStatusAction = (data) => async (dispatch) => {
  try {
    const res = await api.post(`api/Dashboard/trip-status-overview`, data);
    if (res.status === 200 && res?.data) {
      dispatch(DashboardActions.getTripStatus(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getTripFinancialAction = (data) => async (dispatch) => {
  try {
    const res = await api.post(`api/Dashboard/financial-metrics`, data);
    if (res.status === 200 && res?.data) {
      dispatch(DashboardActions.getTripFinancial(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export const getCollaborationAction = (data) => async (dispatch) => {
  try {
    const res = await api.post(
      `api/Dashboard/company-collaboration-metrics`,
      data
    );
    if (res.status === 200 && res?.data) {
      dispatch(DashboardActions.getCollaboration(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  }
};

export default dashboardFiltersReducer.reducer;
